const rpc = 'https://rpc.ankr.com/fantom_testnet/'; //testnet only
export default rpc;